import { render } from "./DailyReportOverview.vue?vue&type=template&id=72d780c9"
import script from "./DailyReportOverview.vue?vue&type=script&lang=js"
export * from "./DailyReportOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__